import { OrderProductConfirmProductScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <OrderProductConfirmProductScreen />;
}
